import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { FormProvider, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { merge } from '../../helpers/Utility';

interface OldFormProps extends Omit<HTMLAttributes<HTMLFormElement>, 'onSubmit'> {
  methods: UseFormReturn<any>;
  onSubmit: SubmitHandler<any>;
}

export const TsForm: FC<OldFormProps> = ({ children, methods, onSubmit, className, ...props }) => {
  return (
    //@ts-ignore Type instantiation is excessively deep and possibly infinite
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className={merge('', className)} {...props}>
        {children}
      </form>
    </FormProvider>
  );
};
export interface FormProps extends Omit<React.HTMLAttributes<HTMLFormElement>, 'onSubmit'> {
  methods: UseFormReturn<any>;
  onSubmit: SubmitHandler<any>;
}

export const Form: FC<PropsWithChildren<FormProps>> = ({ children, methods, onSubmit, className, ...props }) => {
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className={clsx('', className)} {...props}>
        {children}
      </form>
    </FormProvider>
  );
};
